var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64.168,
    height: 46.668,
    viewBox: "0 0 64.168 46.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.162,
    y1: 1,
    x2: 0.107,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edd47a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cab56d"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_person_add_24px",
    d: "M41.834,27.334A11.667,11.667,0,1,0,30.167,15.667,11.664,11.664,0,0,0,41.834,27.334ZM15.584,21.5V12.75H9.75V21.5H1v5.833H9.75v8.75h5.833v-8.75h8.75V21.5ZM41.834,33.167c-7.788,0-23.334,3.908-23.334,11.667v5.833H65.168V44.834C65.168,37.076,49.622,33.167,41.834,33.167Z",
    transform: "translate(-1 -4)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdAddUser);
export default __webpack_public_path__ + "static/media/mdAddUser.97f972422a1b40afcdbc50194db535d1.svg";
export { ForwardRef as ReactComponent };